module.exports = __webpack_public_path__ + "assets/img/A4.34f3c0c4.jpg";